<template>
  <v-layout
    row
    wrap
    align-center
  >
    <v-flex
      text-md-right
      xs12
    >
      <fragment v-if="active <= numberOfSteps">
        <v-btn
          outline
          color="primary"
          type="reset"
          @click="handleReset()"
        >
          {{ $t('button.cancel') }}
        </v-btn>
        <v-btn
          outline
          color="primary"
          :disabled="active === 1"
          @click="changeStep(active - 1)"
        >
          {{ $t('button.back') }}
        </v-btn>
        <v-btn
          color="primary"
          type="submit"
          :loading="form.isSubmitting"
          :disabled="disableSubmit"
        >
          {{ getSubmitLabel() }}
        </v-btn>
      </fragment>
      <v-btn
        v-else
        color="primary"
        @click="changeStep(1)"
      >
        {{ $t('button.return') }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { Fragment } from 'vue-fragment'
import { mapActions } from 'vuex'
import { ACTION_SET_SELECTED_PET } from '../../store/types/pets.types'

export default {
  name: 'StepperButtons',
  components: {
    Fragment,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    active: {
      type: Number,
      required: true,
    },
    numberOfSteps: {
      type: Number,
      required: true,
    },
    changeStep: {
      type: Function,
      required: true,
    },
    disableSubmit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getSubmitLabel() {
      return this.active === this.numberOfSteps
        ? this.$t('button.send')
        : this.$t('button.next')
    },
    handleReset() {
      this.changeStep(1)
      this.setSelectedPet(null)
    },
    ...mapActions({
      setSelectedPet: ACTION_SET_SELECTED_PET,
    }),
  },
}
</script>

<style lang="stylus" scoped>
@media only screen and (max-width: 504px) {
  button {
    width: 100%;
  }
}
</style>
